import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class CppCoiAddProductSliderModelService {
  public addCoiAddProductSlider: BehaviorSubject<boolean>;
  public coiAddSidenav: MatSidenav;
  private activeSliderValue: string;
  cppCoiSliderCloseRqt: Subject<boolean>;
  cppCoiAddModelData: BehaviorSubject<any>;
  public shipToOrDeliverToAccount: number;
  public shipToAccount: number;
  public isCustomerPickup: boolean;
  public newItems: any;

  constructor() {
    this.addCoiAddProductSlider = new BehaviorSubject(false);
    this.cppCoiAddModelData = new BehaviorSubject(EMPTY);
    this.cppCoiSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddCppCoiProductSlider') {
      this.addCoiAddProductSlider.next(true);
      this.cppCoiAddModelData.next(EMPTY);
      this.coiAddSidenav.toggle();
    }
  }

  public setCppCoiSideNav(sideNavObj: MatSidenav) {
    this.coiAddSidenav = sideNavObj;
  }

  public cppCoiClose() {
    this.cppCoiAddModelData.next(EMPTY);
    this.addCoiAddProductSlider.next(false);
    this.coiAddSidenav.close();
  }

  public setData<T>(obj: T) {
    this.cppCoiAddModelData.next(obj);
  }

  public getNewItem() {
    return this.newItems;
  }

  public setNewItem(newItems) {
    this.newItems = [];
    this.newItems = newItems;
  }
}
